<form [formGroup]="form" autocomplete="off" class="form-horizontal m-1x mb-3x mt-3x">

    <div class="form-row">
        <label
                class="col-sm-4 col-form-label"
                for="bezeichnung{{index}}">
            {{ 'COMMON_UI.BETRIEBSTAETTE.BEZEICHNUNG' | translate }}
        </label>
        <div class="col-sm-8">
            <input
                    class="form-control"
                    datevMessagePath="bezeichnung{{objectId}}"
                    formControlName="bezeichnung"
                    id="bezeichnung{{index}}"
                    type="text" utilsCheckValidity utilsControlState
                    utilsMarkRequired utilsValidationMessage/>
        </div>
    </div>

    <div class="mb-5x">
        <h2 class="mb-3x">{{ 'COMMON_UI.BETRIEBSTAETTE.ADRESSE_TITEL' | translate }}</h2>
        <common-ui-adresserfassung
                [(auslandsadresse)]="data.auslandsadresse"
                [(inlandsadresse)]="data.inlandsadresse"
                [readonly]="readonly"
                [index]="index"
                disablePostfachadresse="true"
                singleMode="true">
        </common-ui-adresserfassung>
    </div>

    <div class="mb-5x">
        <h2 class="mb-3x">{{ 'COMMON_UI.BETRIEBSTAETTE.KOMMUNIKATIONSMITTEL_TITEL' | translate }}</h2>
        <common-ui-kommunikationsmittel
                [(data)]="data.kommunikationsmittel"
                [stammdatenTelefonnummern]="stammdaten?.kommunikationsmittel?.telefonnummern"
                [stammdatenInternetadressen]="stammdaten?.kommunikationsmittel?.internet"
                [maxTelefonnummern]="maxTelefonnummern">
        </common-ui-kommunikationsmittel>
    </div>

</form>
